import css from './batchCreator.module.scss';

import { Fragment, memo } from 'react';

import { ErrorPane } from 'core/ui/Error';
import { ActionsRow, FormGroup } from 'core/ui/Form';

import {
  CancelButton,
  PreviewButton,
  SaveButton,
  EditButton,
  TemplateTextarea,
  CardsList,
} from './controls';
import useBatchCreatorForm from './useForm';

type Props = {
  deck: TDeck;
  close: (cards: TWord[] | null) => void;
};

const BatchCreatorForm = ({ deck, close }: Props) => {
  const {
    isFetching,
    onChange,
    onSubmit,
    errors,
    cards,
    isEmpty,
    template,
    step,
    setStep,
  } = useBatchCreatorForm(deck, close);

  return (
    <form className={css.form} onSubmit={onSubmit}>
      {step === 'edit' && (
        <FormGroup title="New word cards">
          <TemplateTextarea
            invalid={errors.length > 0}
            value={template}
            onChange={onChange}
          />
        </FormGroup>
      )}

      {step === 'preview' && (
        <Fragment key="preview">
          <CardsList cards={cards} deck={deck} />

          {errors.length > 0 && (
            <ErrorPane key="errors" log={false} error={errors.join('. ')} />
          )}
        </Fragment>
      )}

      <ActionsRow>
        {step === 'edit' && (
          <PreviewButton
            disabled={isEmpty}
            isLoading={isFetching}
            onClick={onSubmit}
          />
        )}
        {step === 'preview' && (
          <>
            <SaveButton
              disabled={!!errors.length || isEmpty}
              isLoading={isFetching}
              onClick={onSubmit}
            />
            <EditButton
              isLoading={isFetching}
              onClick={() => setStep('edit')}
            />
          </>
        )}
        <CancelButton onClick={() => close(null)} />
      </ActionsRow>
    </form>
  );
};

export default memo(BatchCreatorForm);
